import React from 'react';
import { Modal } from '../ui/Modal';
import { Badge } from '../ui/Badge';
import { Lead, getCampaignDripSchedule } from '../../data/mockLeads';
import { formatShortDate } from '../../lib/utils';
import { CheckCircle2, Clock, AlertCircle, Megaphone } from 'lucide-react';
interface CampaignDripModalProps {
  lead: Lead | null;
  open: boolean;
  onClose: () => void;
}
export function CampaignDripModal({
  lead,
  open,
  onClose
}: CampaignDripModalProps) {
  if (!lead) return null;
  const enrolled = lead.campaignEnrollment.enrolled;
  const campaignName = lead.campaignEnrollment.campaignName;
  const schedule = getCampaignDripSchedule(lead);
  return <Modal open={open} onClose={onClose} title={<div className="flex items-center gap-2" data-id="element-2">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600" data-id="element-3">
            <Megaphone className="w-4 h-4" data-id="element-4" />
          </span>
          <span data-id="element-5">{enrolled ? campaignName : 'No Campaign Enrolled'}</span>
        </div>} subtitle={<div className="flex flex-wrap items-center gap-2 text-xs" data-id="element-6">
          <span data-id="element-7">{lead.name}</span>
          <span className="text-slate-300" data-id="element-8">•</span>
          <span data-id="element-9">{lead.loanPurpose}</span>
          {enrolled && lead.campaignEnrollment.status && <>
              <span className="text-slate-300" data-id="element-10">•</span>
              <Badge variant="blue" data-id="element-11">{lead.campaignEnrollment.status}</Badge>
            </>}
          {enrolled && lead.campaignEnrollment.enrolledDate && <>
              <span className="text-slate-300" data-id="element-12">•</span>
              <span data-id="element-13">
                Enrolled {formatShortDate(lead.campaignEnrollment.enrolledDate)}
              </span>
            </>}
        </div>} data-id="element-1">
      {!enrolled ? <div className="flex flex-col items-center text-center py-8" data-id="element-14">
          <div className="h-12 w-12 rounded-full bg-rose-50 text-rose-600 inline-flex items-center justify-center mb-3" data-id="element-15">
            <AlertCircle className="w-6 h-6" data-id="element-16" />
          </div>
          <h3 className="text-base font-semibold text-slate-900 mb-1" data-id="element-17">
            Not enrolled in a campaign
          </h3>
          <p className="text-sm text-slate-500 max-w-sm" data-id="element-18">
            This lead is missing the expected campaign:{' '}
            <span className="font-medium text-rose-600" data-id="element-19">
              {lead.campaignEnrollment.expectedCampaign || 'Unknown'}
            </span>
            . No drip steps are scheduled.
          </p>
        </div> : !schedule || schedule.length === 0 ? <div className="text-sm text-slate-500 italic" data-id="element-20">
          No drip steps configured for this campaign.
        </div> : <div data-id="element-21">
          <div className="flex items-center justify-between mb-4" data-id="element-22">
            <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-23">
              Scheduled Drip Steps
            </h3>
            <div className="text-xs text-slate-500" data-id="element-24">
              {schedule.filter(s => s.status === 'Sent').length} sent ·{' '}
              {schedule.filter(s => s.status === 'Pending').length} pending
            </div>
          </div>

          <ol className="relative space-y-3 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-slate-200" data-id="element-25">
            {schedule.map(step => {
          const sent = step.status === 'Sent';
          return <li key={step.step} className="relative pl-10" data-id="element-26">
                  <span className={'absolute left-0 top-1 inline-flex h-8 w-8 items-center justify-center rounded-full border-2 ' + (sent ? 'bg-emerald-50 border-emerald-200 text-emerald-600' : 'bg-white border-slate-200 text-slate-400')} data-id="element-27">
                    {sent ? <CheckCircle2 className="w-4 h-4" data-id="element-28" /> : <Clock className="w-4 h-4" data-id="element-29" />}
                  </span>
                  <div className="rounded-xl border border-slate-200 bg-white p-3 hover:border-slate-300 transition-colors" data-id="element-30">
                    <div className="flex items-start justify-between gap-3" data-id="element-31">
                      <div className="min-w-0" data-id="element-32">
                        <div className="flex items-center gap-2 flex-wrap" data-id="element-33">
                          <span className="text-xs font-mono text-slate-400" data-id="element-34">
                            Step {step.step}
                          </span>
                          <span className="font-medium text-slate-900 text-sm" data-id="element-35">
                            {step.name}
                          </span>
                        </div>
                        <p className="text-xs text-slate-500 mt-1" data-id="element-36">
                          {step.description}
                        </p>
                      </div>
                      <div className="shrink-0 text-right" data-id="element-37">
                        <Badge variant={sent ? 'success' : 'blue'} data-id="element-38">
                          {step.status}
                        </Badge>
                        <div className="text-xs text-slate-500 mt-1" data-id="element-39">
                          {formatShortDate(step.scheduledDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>;
        })}
          </ol>
        </div>}
    </Modal>;
}